// test1670
(1670 && 0);
